var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "176px",
    height: "176px",
    viewBox: "0 0 176 176",
    enableBackground: "new 0 0 595.28 176",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9494,
    y1: 172.2112,
    x2: 119.0041,
    y2: 14.4998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0400DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01F8FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_1_)",
    d: "M24.848,9.789h64.883c21.79,0,41.595,8.909,55.948,23.263 C160.033,47.406,168.942,67.21,168.942,89c0,21.789-8.909,41.595-23.263,55.948c-14.354,14.354-34.159,23.263-55.948,23.263H24.848 c-3.947,0-7.531-1.61-10.124-4.204c-2.594-2.593-4.204-6.177-4.204-10.124V24.117c0-3.947,1.61-7.531,4.204-10.124 S20.901,9.789,24.848,9.789L24.848,9.789z M79.237,23.338l0.02-0.031h-5.609c-8.897-0.04-17.939-0.032-27.056,0H24.848 c-0.215,0-0.417,0.093-0.567,0.243c-0.15,0.15-0.243,0.352-0.243,0.568v129.766c0,0.215,0.093,0.417,0.243,0.567 c0.15,0.15,0.352,0.243,0.567,0.243h56.729v-45.428H36.691H25.086l69.771-85.754v45.223h44.887h12.298l-1.483,2.322l0.927-2.29 l-69.906,85.92c15.548,0.644,25.618-1.085,37.998-7.09l0.066-0.162c6.104-3.148,11.659-7.226,16.477-12.044 c11.91-11.91,19.303-28.332,19.303-46.391s-7.392-34.481-19.303-46.391c-10.773-10.773-25.237-17.849-41.265-19.102v0.002 C89.716,23.43,84.505,23.375,79.237,23.338L79.237,23.338z M24.99,109.266h-0.598l0.933-1.462L24.99,109.266L24.99,109.266z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.976eaf27c34271a1541470e3cf77f079.svg";
export { ForwardRef as ReactComponent };